import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes } from '../../../types/common/types';
import { EventTypes, ListItem } from '../types';
import { ButtonColor } from '../../gzIconButton/types';

@customElement('gz-selected-list-item')
export class GzSelectedListItemWebComponent extends LitElement {
  @property({ type: Object, attribute: false, reflect: false })
  item: ListItem;

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    return html`
      <div class="d-flex flew-row align-items-center justify-space-between selected-item">
        <gz-tooltip isEllipsis tooltipText="${this.item?.label}"
          ><gz-text fontSize="${FontSizes.PARAGRAPH_12}" class="d-inline">${this.item?.label}</gz-text></gz-tooltip
        ><gz-icon-button
          icon="ds-icon-delete_large"
          size="${FontSizes.HEADING_3}"
          fontsize="${FontSizes.BODY}"
          buttoncolor="${ButtonColor.SECONDARY}"
          @click="${this.handleDelete}"
        ></gz-icon-button>
      </div>
    `;
  }

  private handleDelete(): void {
    this.dispatchEvent(new CustomEvent(EventTypes.DELETE_ITEM));
    this.remove();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-selected-list-item': GzSelectedListItemWebComponent;
  }
}
